import React, { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import Heading from 'src/components/Heading'

const MonthsFilter = (props) => {

    const [open, setOpen] = useState(false)

    return (
        <>
            {/* Desktop Filter */}
            <div className="border-b border-gray-200 lg:block hidden">
                {props.months.map((month, i) => {
                    return (
                        <div 
                            className={`font-display tracking-normal text-xl hover:text-red duration-300 inline-block cursor-pointer pb-4 ${i === 0 ? 'pr-3' : 'px-3'} ${month === props.currentFilter ? 'text-red' : 'text-darkgrey'}`}
                            onClick={() => props.setCurrentFilter(month)}
                            onKeyPress={() => props.setCurrentFilter(month)}
                            role="button"
                            tabIndex="0"
                            key={i}
                        >
                            {month}
                        </div>
                    )
                })}
            </div>
            {/* Mobile Filter */}
            <div 
                className="lg:hidden block focus:outline-none bg-[#1C1B1A] cursor-pointer py-3 text-lg uppercase font-display tracking-normal text-white font-medium text-center w-screen left-[calc(50%-50vw)] -transform-x-1/2 relative"
                onClick={() => setOpen(true)}
                onKeyPress={() => setOpen(true)}
                role="button"
                tabIndex="0"
            >
                FILTER
                <i className="fal fa-plus ml-2"></i>
            </div>
            <div className="mt-8 border-b lg:border-transparent border-gray-200 pb-4 lg:hidden">
                <Heading size="h4" className="text-red lg:hidden inline-block mb-1">{props.currentFilter}</Heading>
            </div>
            {/* Mobile Filter Popup */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="fixed z-50 inset-0 overflow-y-auto" onClose={setOpen}>
                    <div className="flex items-end justify-center min-h-screen text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden align-middle h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 sm:scale-95"
                        enterTo="opacity-100 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 sm:scale-100"
                        leaveTo="opacity-0 sm:scale-95"
                    >
                        <div className="inline-block min-h-screen w-full align-bottom bg-[#1C1B1A] text-left overflow-hidden shadow-xl transform transition-all">
                            <div className="bg-white pb-3 pt-10 shadow px-6 flex flex-row justify-between items-center">
                                <button className="text-darkgrey font-display tracking-normal uppercase text-xl flex items-center w-full focus:outline-none" onClick={() => setOpen(false)}>
                                    <i className="fal fa-angle-left mr-2"></i>
                                    Filters
                                </button>
                                <button
                                    type="button"
                                    className="bg-white rounded text-darkgrey focus:outline-none"
                                    onClick={() => setOpen(false)}
                                >
                                    <span className="sr-only">Close</span>
                                    <XIcon className="h-7 w-7" aria-hidden="true" />
                                </button>
                            </div>
                        <div className="w-full px-6 pt-12">
                            <div className="flex flex-col gap-1">
                                {props.months.map((month, i) => {
                                    return (
                                        <div 
                                            className={`font-display tracking-normal focus:outline-none text-xl hover:text-red duration-300 !leading-none flex flex-row items-center cursor-pointer pb-4 ${month === props.currentFilter ? 'text-red' : 'text-white'}`}
                                            onClick={() => {props.setCurrentFilter(month); setOpen(false)}}
                                            onKeyPress={() => {props.setCurrentFilter(month); setOpen(false)}}
                                            role="button"
                                            tabIndex="0"
                                            key={i}
                                        >
                                            <div className="bg-white h-6 w-6 mr-2 flex justify-center items-center">
                                                <div className={`h-4 w-4 ${month === props.currentFilter ? 'bg-red' : 'bg-white'}`}></div>
                                            </div>
                                            {month}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        </div>
                    </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
};

export default MonthsFilter